export const method = 'post';

export default {
    message: 'success',
};